import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    frequencies: {count: 0, rows: []},
    frequenciesFilter: {},
    frequency: {},
    loading: false,
    checkDelete: {},
};

const setFrequenciesFilter = (state, action) => {
  return updateObject(state, {
    frequenciesFilter: action.frequenciesFilter,
  });
};

const requestFrequencyStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchFrequencySuccess = ( state, action ) => {
    return updateObject( state, {
        frequencies: action.frequencies,
        loading: false
    } );
};

const fetchFrequencyByIdSuccess = (state, action) => {
    return updateObject(state, {
      frequency: action.frequency,
      loading: false
    });
  }

const requestFrequencyFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const deleteFrequencySuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const checkDeleteFrequencySuccess = (state, action) => {
  return updateObject(state, { 
    checkDelete: action.checkDelete,
    loading: false 
  });
}

const updateFrequencySuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const postFrequencySuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.REQUEST_FREQUENCY_START: return requestFrequencyStart( state, action );
        case actionTypes.FETCH_FREQUENCY_SUCCESS: return fetchFrequencySuccess( state, action );
        case actionTypes.FETCH_FREQUENCY_BY_ID_SUCCESS: return fetchFrequencyByIdSuccess(state, action);
        case actionTypes.REQUEST_FREQUENCY_FAIL: return requestFrequencyFail( state, action );
        case actionTypes.DELETE_FREQUENCY_SUCCESS: return deleteFrequencySuccess( state, action );
        case actionTypes.CHECK_DELETE_FREQUENCY_SUCCESS: return checkDeleteFrequencySuccess(state, action);
        case actionTypes.UPDATE_FREQUENCY_SUCCESS: return updateFrequencySuccess( state, action );
        case actionTypes.POST_FREQUENCY_SUCCESS: return postFrequencySuccess( state, action );
        case actionTypes.SET_FREQUENCIES_FILTER: return setFrequenciesFilter(state, action);

        default: return state;
    }
};

export default reducer;